export default "__VITE_PUBLIC_ASSET__15daa09c__"